import { useTheme } from "@mui/material"

const useStyles = () => {
    const { palette } = useTheme()
    return {
        container: {
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            '& .separator': {
                borderBottom: `1px solid ${palette.grey[400]}`,
                paddingBottom: '5px'
            }
        },
        setting: {
            display: 'flex',
            alignItems: 'center',
            gap: 2
        },
        users: {
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            padding: '24px 0px 0px'
        },
        scroll: {
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            padding: '0px 24px 24px',
            maxHeight: '250px',
            overflowY: 'auto'
        },
        btnContainer: {
            display: 'flex',
            width: '100%',
            justifyContent: 'flex-end',
            gap: 2
        }
    }
}

export { useStyles }